import cn from "classnames";

import snailIcon from "src/assets/icons/snail.svg";
import { Select } from "src/shared/ui/Select";
import ultrabulletIcon from "src/assets/icons/ultraBulllet.svg";
import rabbitIcon from "src/assets/icons/rabbit.svg";
import bulletIcon from "src/assets/icons/Bullet.svg";
import flashIcon from "src/assets/icons/lightning.svg";
import useStores from "src/hooks/useStores";

import { GameTimeValues } from "src/store/lobbyStore";

import { useStyles } from "./styles";
import { useEffect } from "react";
import { useLocale } from "../../../../providers/LocaleProvider";

export const TimeSelect = () => {
    const classes = useStyles();
    const { lobbyStore } = useStores();
    const timeConfig = lobbyStore.timeConfig.value;

    const {
        lobby: {
            time: { min },
        },
    } = useLocale();

    const timeOptions = [
        {
            value: GameTimeValues["2m"],
            label: `2 ${min("min")}`,
            icon: <img src={ultrabulletIcon} className={classes.betSelectIcon} />,
        },
        {
            value: GameTimeValues["3m"],
            label: `3 ${min("min")}`,
            icon: <img src={bulletIcon} className={classes.betSelectIcon} />,
        },
        {
            value: GameTimeValues["5m"],
            label: `5 ${min("min")}`,
            icon: <img src={flashIcon} className={classes.betSelectIcon} />,
        },
        {
            value: GameTimeValues["10m"],
            label: `10 ${min("min")}`,
            icon: <img src={rabbitIcon} className={classes.betSelectIcon} />,
        },
        {
            value: GameTimeValues["20m"],
            label: `20 ${min("min")}`,
            icon: <img src={snailIcon} className={classes.betSelectIcon} />,
        },
    ];

    return (
        <Select<number>
            value={timeConfig}
            onChange={(value) => {
                lobbyStore.setTimeConfigValue(value);
            }}
            options={timeOptions}
            renderEmptyLabel={() => {
                return <div>Empty</div>;
            }}
            renderLabel={(option) => {
                return (
                    <div className={classes.betSelectLabelWrapper}>
                        <div className={classes.betSelectLabelIcon}>
                            {option.icon}
                        </div>
                        <span className={classes.betSelectLabel}>
                            {option.label}
                        </span>
                    </div>
                );
            }}
            renderOption={(option, selected) => {
                return (
                    <div
                        className={cn(classes.betOption, {
                            [classes.betOptionSelected]: selected,
                        })}
                    >
                        <div
                            className={cn(classes.betDropdownOptionIcon, {
                                [classes.betDropdownOptionIconSelected]:
                                    selected,
                            })}
                        >
                            {option.icon}
                        </div>
                        <span className={classes.betDropdownOptionLabel}>
                            {option.label}
                        </span>
                    </div>
                );
            }}
        />
    );
};
